function validation(paint) {
    let errors = {}

    // title
    if (!paint.title) {
        errors.title = 'تیتر را وارد نکردید.'
    } else if (!paint.title.trim()) {
        errors.title = 'تیتر را وارد نکردید.'
    } else if (paint.title.length > 90) {
        errors.title = 'طول تیتر نباید بیشتر از 90 کارکتر باشد.'
    } else {
        delete errors.title
    }
    // artist
    if (!paint.artist_id) {
        errors.artist_id = 'لطفا هنرمند را وارد کنید.'
    } else {
        delete errors.artist_id
    }
    // images
    if (!paint._method && !paint.images.length) {
        errors.images = 'لطفا عکس اصلی را وارد کنید.'
    } else {
        delete errors.images
    }
    // width_pixel
    if (!paint.width_pixel) {
        errors.width_pixel = "الزامی"
    } else {
        delete errors.width_pixel
    }
    // height_pixel
    if (!paint.height_pixel) {
        errors.height_pixel = "الزامی"
    } else {
        delete errors.height_pixel
    }
    // body
    if (paint.body?.length > 20000) {
        errors.body = "طول توضیحات نباید بیش از 20000 کارکتر باشد"
    } else {
        delete errors.body
    }

    return errors
}
export default validation;